import { render, staticRenderFns } from "./TextDownloadButton.vue?vue&type=template&id=2da39177&"
import script from "./TextDownloadButton.vue?vue&type=script&lang=js&"
export * from "./TextDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports